<script>
/**
 * @overview 素材管理 - 入口列表
 *
 * @author huojinzhao
 */

import mapUtils, { $list, $form } from "@/utils";
import $store from "@/store";
import { mapState, mapGetters } from "vuex";
import AppTree from './../../components/AppTree/index.vue';
import MenuItem from '../../components/MenuItem/index.vue';
import AddMenu from './AddMenu.vue';
import AppCopyOrMove from "./../../components/AppCopyOrMove/index.vue";
import EditorPdf from './components/EditorPdf.vue';
import EditFlash from './components/EditFlash.vue';
import EditFlashName from './components/EditFlashName/index.vue';
import SelectLabel from './components/SelectLabel/index.vue';
import EditLabel from './components/EditLabel/index.vue';
import * as materialManageServer from '../../api/materialManage';

export default {
  name: "ViewMaterial",
  components: {
    AppTree,
    MenuItem,
    AddMenu,
    AppCopyOrMove,
    EditorPdf,
    EditFlash,
    EditFlashName,
    SelectLabel,
    EditLabel,
  },

  data: () => ({
    isInitial: false, // 是否是第一次刷新数据
    subject_id: null, // 学科
    structure_id: null, // 学科结构

    isCopyOrMove: false, // 复制或移动弹窗
    showType: 'copy', // 复制或移动类型
    showData: [], // 复制或移动数据集
    optId: '', // 操作id

    menusData: [], // 菜单所有数据
    menu: [], // 一级菜单
    menuSelect: '', // 一级菜单选中值
    menuTwo: [], // 二级菜单
    menuTwoSelect: '', // 二级菜单选中值

    isAddMenu: false, // 是否添加二级目录
    parentId: -1, // 新建目录父级id

    loading: {
      fetch: false,
    },

    list: {
      current_page: 1,
      data: [],
    },

    query: {
      per_page: 20,
    },

    editor: {
      visible: false,
      data: null,
    },

    structureProps: {
      children: "leaf",
      value: "id",
      label: "name",
    },
    // 是否编辑闪卡名称
    editorFlashName: false,
    oldFlashName: '', // 辅师闪卡名称
    flashId: '', // 辅师闪卡id

    // 是否编辑标签
    isLabel: false,
    labelType: null, // 默认选中标签
    labelTop: '', // 标签弹窗默认高度-弹窗默认初始位置不遮盖图片

    selectedList: [], // 选中集合
  }),

  computed: {
    ...mapState("course", ["subjects", "structure"]),
    ...mapGetters(['getPermissionsMoveMaterial']),
    // 新建目录列表
    getAddMenuList() {
      let list = this.menu;
      try {
        list = list.filter(v => `${v.id}` !== '500');
      } catch (e) {
        console.log('过滤失败==>', e);
      }
      return list;
    },
    // 是否是辅师闪卡
    isFlash() {
      return this.qiniuType === 'flash';
    },
    // 是否是未归类项
    isUnLog() {
      let state = false;
      try {
        if (`${this.menuSelect}` === `${this.menuTwoSelect}`) {
          state = true;
        }
      } catch (e) {
        console.log('未归类失败==>', e);
      }
      return state;
    },
    materialType() {
      return Number(this.$route.query["equal[type]"]);
    },

    qiniuType() {
      const typeMap = {
        1: 'image',
        2: 'audio',
        3: 'video',
        4: 'pdf',
        5: 'doc',
        21: 'animation',
        500: 'flash',
      };

      return typeMap[this.menuSelect] || '';
    },

    // 获取最新学科结构id
    getNewStructureId() {
      let id = '';
        if (typeof this.structure_id === 'string') {
          id = this.structure_id.split(',').pop();
        } else if (Array.isArray(this.structure_id)) {
          id = JSON.parse(JSON.stringify(this.structure_id)).pop();
        }
      return id;
    },
    // 获取正在编辑的辅师闪卡名称 去掉后缀
    getFlashName() {
      let name = this.oldFlashName;
      if (name) {
        name = name.split('.')[0];
      }
      return name;
    },
  },

  // beforeRouteEnter(to, from, next) {
  //   const initType = $store.state.material.types[0].value;
  //
  //   const query = $list.routeQuery(
  //     {
  //       page: 1,
  //       "equal[type]": initType,
  //     },
  //     to.query,
  //   );
  //
  //   to.query["equal[type]"] ? next() : next({ ...to, query });
  // },

  created() {
    this.$nextTick(() => {
      // 获取菜单列表
      this.initMenu(null, true);
    });
  },

  beforeRouteUpdate(to, from, next) {
    // this.fetchList(to);

    next();
  },

  methods: {
    // 图片选中的集合
    handleSelected(item) {
      if (`${this.menuSelect}` !== `1`) {
        return false;
      }
      if (this.selectedList.includes(item.id)) {
        this.selectedList.splice(this.selectedList.indexOf(item.id), 1);
        return false;
      }
      this.selectedList.push(item.id);
    },
    queryPage(value) {
      this.query.page = value;

      this.fetchList();
    },
    ...mapUtils("list", [
      "deleteAlert",
      "fetch",
      "routeQuery",
      "routePageIndex",
    ]),

    ...mapUtils("form", ["submit", "errorAlert"]),

    // 标记改变
    selectLabelChange(value) {
      this.labelType = value;
      this.fetchList();
    },
    // 初始化一级菜单和二级菜单
    async initMenu(item, initail = false) {
      try {
        const res = await materialManageServer.queryResourceTypes();
        const units = await materialManageServer.queryUnitList();
        const data = res.courseware_resource_types;
        // 隐藏图片 pdf word 未归类二级目录
        data.map((v) => {
          if ([1, 4, 5].includes(v.type_id) && v.leaf && Array.isArray(v.leaf)) {
            v.leaf = v.leaf.filter(q => q.type_id !== v.type_id);
          }
        });
        // 设置辅师二级目录为单元列表
        console.log('222=>2', units);
        data.map((v) => {
          if (`${v.type_id}` === '500') {
            v.leaf = units.map(q => ({ name: q.name, type_id: q.id }));
          }
        });
        this.menusData = data;
        this.menu = data.map(v => ({
          id: v.type_id,
          value: v.name,
        }));

        // 过滤掉id为30
        if (this.menu && this.menu.length > 0) {
          this.menu = this.menu.filter(v => v.id !== 30);
        }

        if (initail) {
          this.menuSelect = this.$route.query.parentId || (this.menu && this.menu[0] && this.menu[0].id);
        }
        this.onBack(item || this.$route.query.parentId || this.menu[0], initail);
        // 初始化学科选择
        this.initialSubject();
      } catch (e) {
        console.log('err==>', e);
      }
    },
    queryType(value, initial = false) {
      this.menuTwoSelect = value;
      this.list.current_page = 1;
      this.query.page = 1;
      const query = { page: 1, "equal[type]": value, parentId: this.menuSelect };

      // query["like[name]"] = "";
      // this.query["like[name]"] = "";

      // 判断当前是否是辅师闪卡
      switch (`${this.menuSelect}`) {
        case '500':
          // 辅师闪卡
          if (this.getNewStructureId) {
            query['equal[structure_id]'] = this.getNewStructureId;
          } else if (!query['equal[structure_id]'] && this.$route.query.structure_id) {
            const arr = this.$route.query.structure_id.split(',');
            query['equal[structure_id]'] = arr[arr.length - 1];
          }
          break;
      }
      this.$list_routeQuery(query);
      this.fetchList();
    },

    queryName(nameQuery) {
      this.list.current_page = 1;
      this.query.page = 1;
      this.query = { ...this.query, ...nameQuery };

      const query = { page: 1, ...this.query };

      // this.$list_routeQuery(query);
      this.fetchList();
    },

    // 辅师闪卡筛选，先设置路由参数后刷新
    getNewFetchList() {
      const query = {
        ...this.$route.query,
        ...this.query,
        subject_id: this.subject_id,
        structure_id: this.structure_id.toString(),
      };
      this.$list_routeQuery(query);
      this.fetchList();
    },

    async fetchList(route = this.$route) {
      const query = { ...route.query, ...this.query };

      this.loading.fetch = true;

      // 如果是辅师入口列表参数传递为 equal[type] = '500' | equal[structure_id] | equal[unit_id]
      if (this.isFlash) {
        delete query['equal[type]'];
        query['equal[unit_id]'] = this.menuTwoSelect;
        const nowStructureId = query['equal[structure_id]'];
        if (nowStructureId && Array.isArray(nowStructureId)) {
          query['equal[structure_id]'] = nowStructureId[nowStructureId.length - 1];
        }
        if (this.getNewStructureId) {
          query['equal[structure_id]'] = this.getNewStructureId;
        }
        const res = await materialManageServer.queryFlashCard(query);
        this.list = res;
        this.loading.fetch = false;
        return false;
      }
        delete query['equal[structure_id]'];

      delete query['equal[is_tag]'];
      if (`${this.menuSelect}` === '1' && Number.isInteger(this.labelType)) {
        query['equal[is_tag]'] = this.labelType;
      }

      console.log('2222', this.menuSelect, query);


      this.$list_fetch("/resource", query)
        .then((data) => {
          this.list = data;
        })
        .finally(() => {
          this.loading.fetch = false;
        });
    },

    materialEdit({ url }, id) {
      this.loading.fetch = true;
      const name = url.split("/").pop();

      const uri = "/resource";
      const data = { name, url, type: this.materialType };

      this.$form_submit({ uri, data, id })
        .then(() => this.materialResponse(id))
        // .catch(this.$form_errorAlert)
        .catch((error) => {
          this.$form_errorAlert(error);
          setTimeout(() => {
            this.fetchList();
          }, 1000);
        })
        .finally(() => {
          this.loading.fetch = false;
        });
    },

    materialDelete(id) {
      switch (`${this.menuSelect}`) {
        case '500':
          // 辅师闪卡
          this.$confirm(
                  `确定删除该选项吗？`,
                  "删除确认",
                  {
                    showCancelButton: true,
                    type: "warning",
                    confirmButtonText: "删除",
                    confirmButtonClass: "el-button--danger",
                    // beforeClose,
                  },
          ).then((res) => {
            materialManageServer.deleteFlashCard({ id })
                    .then((_) => {
                      this.fetchList();
                    }).catch((err) => {
                this.$message.error('添加辅师闪卡失败');
            });
          });

          break;
        default:
          this.$list_deleteAlert(id, this.list.data, "素材", "/resource");
      }
    },

    materialResponse(id) {
      id || Number(this.$route.query.page) === 1
        ? this.fetchList()
        : this.$list_routePageIndex(1, this.route);
    },
    // 选中菜单回调
    onBack(item, initail = false) {
      try {
        this.initialSubject();
        const id = typeof item === 'string' ? item : item.id;
        // this.$route.query['like[name]'] = '';
        // this.query["like[name]"] = "";
        this.menuSelect = id;
        // 二级菜单
        let arr = [];
        this.menusData.map((v) => {
          if (`${v.type_id}` === `${id}`) {
            arr = v.leaf;
          }
        });
        this.menuTwo = arr.map(v => ({
            id: v.type_id,
            value: v.name,
          }));
        let typeId = this.menuTwo[0].id;
        if (initail) {
          typeId = this.$route.query['equal[type]'] || this.menuTwo[0].id;
        }
        this.queryType(typeId, initail);
      } catch (e) {
        console.log('err==>', e);
      }
    },
    // 添加二级回调
    onAddMenu() {
      this.initMenu({ id: this.menuSelect });
    },
    // 添加二级目录
    handleAddMenu(parentId) {
      this.parentId = parentId;
      this.isAddMenu = true;
    },

    // 复制
    materialFuzhi(item) {
      console.log('复制==>', item);
      this.optId = item.id;
      this.showCopyOrMove('copy');
    },

    // 移动
    materialMove(item) {
      console.log('移动==>', item);
      this.optId = item.id;
      this.showCopyOrMove('move');
    },

    // 标签
    materialLabel(item, type) {
      if (type && this.selectedList.length <= 0) {
        this.$message.error("请先选中需要打标签的元素");
        return false;
      }
      console.log('标签==>', item, type);
      this.isLabel = true;
      this.optId = item;
    },

    // 复制或移动业务
    showCopyOrMove(type) {
      this.isCopyOrMove = true;
      this.showType = type;
      let logs = [];
      // TODO 获取复制或移动的数据
      switch (type) {
        case 'copy':
          // this.showData = logs;
          // this.$refs.optLog.selected(this.selectedId);
          break;
        case 'move':
          logs = this.menuTwo.map(v => ({ key: v.id, value: v.value }));
          this.showData = logs && logs.filter(v => (`${v.key}` !== `${this.menuSelect}` && `${v.key}` !== `${this.menuTwoSelect}`));
          break;
        default:
      }
    },

    // 复制或移动回调
    async onCopyOrMove(select, type) {
      try {
        const res = null;
        switch (type) {
          case 'copy':
            console.log('复制回调==>', type);
            break;
          case 'move': {
            console.log('移动回调==>', select, type);
            switch (`${this.menuSelect}`) {
              case '500':
                // 辅师闪卡
                await materialManageServer.moveFlashCard({ id: this.optId, unit_id: select });
                break;
              default:
                await materialManageServer.moveResource({ id: this.optId, type_id: select });
            }
            break;
          }
          default:
        }
        this.clearAll();
        this.fetchList();
      } catch (e) {
        this.$message.error('操作失败', e);
      }
    },
    // 清除设置
    clearAll() {
      this.optId = '';
    },
    // 初始化学科 && 学科结构
    initialSubject() {
      try {
        this.subject_id = this.subjects[0].id;
        const self = this;
        this.$store.dispatch("course/initStructure", this.subject_id).then((structure) => {
          let arr = structure.split(',');
          arr = arr.map(v => parseInt(v, 10));
          self.structure_id = arr;

          // 初始化 如果存在学科及学科结构 设置历史值
          if (this.$route.query.subject_id) {
            self.subject_id = parseInt(this.$route.query.subject_id, 10);
            this.querySubject(self.subject_id);
          }
          let oldStructureId = '';
          if (this.$route.query.structure_id) {
            let arr1 = this.$route.query.structure_id.split(',');
            arr1 = arr1.map(v => parseInt(v, 10));
            self.structure_id = arr1;
            oldStructureId = arr1.toString();
          }

          // 设置路由参数
          this.$list_routeQuery({
            ...this.$route.query,
            ...this.query,
            subject_id: self.subject_id,
            structure_id: oldStructureId || structure,
            'equal[structure_id]': self.structure_id,
          });
        });
      } catch (e) {
        console.log('初始化学科==>', e);
      }
    },
    // 自己处理的回调 - 添加
    onSelf() {
      console.log('self-add==>', this.menuSelect);
      switch (`${this.menuSelect}`) {
        case '4':
          // pdf
          this.editor.visible = true;
          break;
        case '500':
          // 辅师闪卡
          this.editor.visible = true;
          break;
      }
    },
    // 编辑pdf成功回调
    editorPdfResponse() {
      console.log('pdf回调');
      this.clearData();
      this.fetchList();
    },
    // 编辑flash成功回调
    editorFlashResponse(url, data, isMul) {
      console.log('flash回调', url, data, isMul);

      // 如果isMul 为true 表示多选
      if (isMul) {
        const newData = data.map(v => ({
            resource_id: v.id,
            subject_id: this.subject_id,
            structure_id: this.getNewStructureId,
            unit_id: this.menuTwoSelect,
            structure_id_str: this.structure_id.toString(),
          }));
        materialManageServer.addMulFlashCard(newData).then((res) => {
          this.fetchList();
        }).catch((res) => {
          this.$message.error("批量新增辅师闪卡失败");
        });
        return false;
      }

      // 添加辅师闪卡
      materialManageServer.addFlashCard({
        resource_id: data.id,
        subject_id: this.subject_id,
        structure_id: this.getNewStructureId,
        unit_id: this.menuTwoSelect,
        structure_id_str: this.structure_id.toString(),
      }).then((res) => {
        this.fetchList();
      }).catch((res) => {
        this.$message.error("新增辅师闪卡失败");
      });
    },
    // 编辑辅师闪卡名称
    handleEditorFlashName({ name }) {
      console.log('999', name);
      if (this.flashId && name) {
        const arr = this.oldFlashName.split('.');
        const newName = `${name}.${arr[arr.length - 1]}`;
        materialManageServer.editFlashCard({ id: this.flashId, name: newName }).then((res) => {
          this.clearFlashName();
          this.fetchList();
        }).catch((res) => {
          this.$message.error("编辑辅师闪卡失败");
        });
      }
    },
    // 编辑编辑
    // obj 表单参数
    // typeList 多选集合
    handleEditorLabel(obj, typeList) {
      if (typeList && Array.isArray(typeList)) {
        const arr = [];
        typeList.map(async (v) => {
          arr.push(await materialManageServer.updateResource({ id: v, type: this.menuTwoSelect, ...obj }));
        });
        this.selectedList = [];
        const fn = setTimeout(() => {
          this.fetchList();
          clearTimeout(fn);
        }, 0);
        this.$message.success("标签编辑成功");
        return false;
      }
      console.log('9992', obj, this.optId);
      materialManageServer.updateResource({ id: this.optId.id, type: this.optId.type, ...obj }).then((res) => {
        this.fetchList();
        this.$message.success("标签编辑成功");
      }).catch((res) => {
        this.$message.error("标签编辑失败");
      });
    },
    // 清除辅师闪卡名称
    clearFlashName() {
      this.oldFlashName = '';
      this.flashId = '';
    },
    // 清除历史数据
    clearData() {
      this.editor.data = null;
    },
    // 自己处理的回调 - 编辑
    onSelfEdit(data) {
      console.log('self-edit==>', this.menuSelect, data);

      switch (`${this.menuSelect}`) {
        case '4':
          // pdf
          this.editor.data = {
            ...data,
          };
          this.editor.visible = true;
          break;
        case '500':
          // 辅师闪卡
          this.editorFlashName = true;
          this.flashId = data.id;
          this.oldFlashName = data.name;
          break;
      }
    },
    // 获取学科结构
    querySubject(subject) {
      this.$store
              .dispatch("course/initStructure", Number(subject))
              .then((structure) => {
                const query = {
                  ...this.query,
                  subject,
                  structure,
                  page: 1,
                };
              });
    },

    // 手动选学科后 学科结构为空
    handleChangeSubject(subject) {
      this.querySubject(subject);
      this.structure_id = [];
    },
  },
};
</script>

<template>
  <div
    v-loading="loading.fetch"
    class="layout-screen view-material">
    <TheHeader/>

    <div class="content-box">
      <AppTree
        :form="menu"
        :select="menuSelect"
        @onBack="onBack"
      />
      <div class="list-box">
        <div class="search-box">
          <div class="menu-box-top">
            <div
              v-if="isFlash"
              class="select-box">
              <el-select
                v-model="subject_id"
                size="small"
                class="select-subject"
                @change="handleChangeSubject">
                <el-option
                  v-for="subject in subjects"
                  :key="subject.id"
                  :label="subject.name"
                  :value="subject.id"
                />
              </el-select>

              <el-cascader
                v-model="structure_id"
                :options="structure"
                :props="structureProps"
                class="select-subject"
                size="small"
                placeholder="请选择学科以及对应课时"
                @change="getNewFetchList"
              />
            </div>
            <menu-item
              :data="menuTwo"
              :value="menuTwoSelect"
              @change="queryType"
            />
          </div>
          <div class="btn-box">
            <p>
              <el-dropdown
                @command="handleAddMenu">
                <el-button
                  type="primary"
                  size="small">
                  新建目录<i class="el-icon-arrow-down el-icon--right"/>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item,key) in getAddMenuList"
                    :key="key"
                    :command="item.id"
                  >{{ item.value }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </p>
            <div class="options-box">
              <el-button
                v-if="`${menuSelect}`===`1`"
                style="margin-right: 10px;"
                size="small"
                @click="materialLabel(selectedList, true)"
              >打标签</el-button>
              <SelectLabel
                v-if="`${menuSelect}`===`1`"
                :value.sync="labelType"
                class="select-box"
                @change="selectLabelChange"
              />
              <AppQueryName
                :value.sync="$route.query['like[name]']"
                @query="queryName"/>
            </div>
          </div>
        </div>
        <AppList>
          <AppQiniu
            v-if="qiniuType != 'animation' && !isUnLog && !['3','4','500'].includes(`${menuSelect}`)"
            type="rar"
            width="225px"
            height="225px"
            class="view-material__item view-material__item_more"
            token-url="/resource/upload_token"
            token-mode="name"
            @success="data => materialEdit(data)"
          />

          <AppQiniu
            v-if="!isUnLog"
            :type="qiniuType"
            :is-self="['pdf','flash'].includes(qiniuType)"
            width="225px"
            height="225px"
            class="view-material__item"
            token-url="/resource/upload_token"
            token-mode="name"
            @success="data => materialEdit(data)"
            @onSelf="onSelf"
          />

          <AppQiniu
            v-for="material in list.data"
            :name="material.name"
            :key="material.id"
            :value="material.url+'?v='+Math.random()"
            :preview-url="material.preview_url"
            :type="qiniuType"
            :is-self="['pdf','flash'].includes(qiniuType)"
            :is-move-permissions="getPermissionsMoveMaterial"
            :is-label="`${menuSelect}`===`1`"
            :class="{'qiniu-active': selectedList.includes(material.id)}"
            width="225px"
            height="225px"
            class="view-material__item"
            token-url="/resource/upload_token"
            token-mode="name"
            preview
            @success="data => materialEdit(data, material.id)"
            @delete="() => materialDelete(material.id)"
            @move="materialMove(material)"
            @label="materialLabel(material)"
            @onSelfEdit="onSelfEdit(material)"
            @create="handleSelected(material)"
          >
            <span
              slot="preview-footer"
              class="layout-ellipsis module-list-item-label"
            >{{ material.name }}</span>
          </AppQiniu>
        </AppList>

        <TheFooter>
          <AppPagination
            :list="list"
            :size="query.per_page"
            class="view-material__pagination"
            router
            @changeIndex="queryPage"
          />
        </TheFooter>
      </div>
    </div>

    <AddMenu
      :visible.sync="isAddMenu"
      :parent-id="parentId"
      @success="onAddMenu"
    />
    <AppCopyOrMove
      ref="optLog"
      :visible.sync="isCopyOrMove"
      :data="showData"
      :type="showType"
      @success="onCopyOrMove"
    />

    <!--编辑pdf-->
    <EditorPdf
      v-if="qiniuType==='pdf'"
      :visible.sync="editor.visible"
      :data="editor.data"
      :type="menuTwoSelect"
      @success="editorPdfResponse"
      @clearData="clearData"
    />
    <!--编辑辅师闪卡-->
    <EditFlash
      v-if="isFlash"
      :visible.sync="editor.visible"
      :is-mul="`${menuSelect}`===`500`"
      @success="editorFlashResponse"
    />
    <!--编辑闪卡名称-->
    <EditFlashName
      v-if="isFlash && editorFlashName"
      :visible.sync="editorFlashName"
      :name="getFlashName"
      @success="handleEditorFlashName"
    />
    <!--编辑标签-->
    <EditLabel
      v-if="isLabel"
      :item.sync="optId"
      :visible.sync="isLabel"
      @success="handleEditorLabel"
    />
  </div>
</template>

<style lang="postcss" scoped>
.qiniu-active{
  border: 1px solid #00bfff;
  border-radius: 10px;
}
.view-material {
  display: flex;
  flex-direction: column;
}

.view-material__item {
  margin: 15px 20px;
}
.view-material__item_more ::before {
  content: "批量上传";
  font-size: 2rem;
}

.view-material .module-list-item-label {
  flex-shrink: 0;
}

.view-material__pagination {
  margin: auto;
}
.app-qiniu {
  margin-left: 10px;
}
.content-box{
  display: flex;
  flex-direction: row;
  min-height: calc(100vh - 60px);
}
.list-box{
  display: flex;
  flex-direction: column;
  min-width: calc(100% - 201px);
}
.search-box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 30px;
  padding-top: 10px;
}
.btn-box{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}


.btn-box .select-box{
  margin-right: 10px;
}
.options-box{
  display: flex;
  flex-direction: row;
}
.menu-box-top{
  display: flex;
  flex-direction: column;
  justify-items: center;
}
.menu-box-top .select-subject{
  width: 200px;
  margin-right: 10px;
  margin-top: 20px;
}
</style>
